import { CircleSlash } from "lucide-react";
import { StatusShell } from "./StatusShell";

export default function PaymentCancel() {
  return (
    <StatusShell
      testid="payment-cancel"
      icon={<CircleSlash className="h-10 w-10 text-pink" />}
      title="No worries — nothing was charged."
      text="You can still grab your 5 free recordings, or subscribe whenever you're ready."
    />
  );
}
